import { Component, OnInit, NgZone, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as firebase from 'firebase';
import { AlertService } from "../../_services/alert.service";
import { Subscription } from "rxjs";
import { UserService } from "../../_services/user.service";
import { PostService } from "../../_services/post.service";
@Component({
  selector: 'app-auth-actions',
  templateUrl: './auth-actions.component.html',
  styleUrls: ['./auth-actions.component.css']
})
export class AuthActionsComponent implements OnInit {

  updatePasswordModel: any = {};
  oobCode: any;
  mode: any;
  loading: boolean;
  isPostExist: boolean;
  error: any = {};
  model: any = {};
  private subscription: Subscription = new Subscription();
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    private router: Router,
    private postService: PostService,
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.subscription.add(this.route.queryParams.subscribe(async params => {
      this.oobCode = params["oobCode"];
      this.mode = params["mode"];
      let customToken = params["customToken"];
      if (this.mode == "verifyEmail" && params["customToken"]) {
        try {
          firebase.auth().signInWithCustomToken(customToken).then(_user => {
            if (_user.uid) {
              localStorage.setItem("currentUserId", _user.uid);
              this.userService.setUser(_user.uid);
   
              let verify = firebase.database().ref("verifyEmail/" + _user.uid).set({ isEmailVerified: false });
              verify.then(() => this.zone.run(() => this.router.navigate(["/home"])))
            }
          })
            .catch(err => {
              switch (err.code) {
                case "auth/invalid-custom-token":
                  firebase.database().ref("users").orderByChild("customToken").equalTo(customToken).once("value", snap => {
                    if (snap.exists()) {
                      snap.forEach(data => {
                        if (data.child("isEmailVerified").val()) {
                          this.error = { type: "AlreadyVerified", message: data.child("firstname").val() + " " + data.child("lastname").val() + ", epostan daha önceki bir tarihte onaylanmıştır. Doğrudan giriş yapmayı deneyebilirsin." }
                        } else {
                          this.error = { type: "expireAndUserFound", message: "Gönderilen kayıt epostasının onay süresi dolmuştur. Eposta tekrardan gönderilmiştir. Lütfen eposta kutunu tekrardan kontrol et." }
                          var user = data.val();
                          this.userService.sendEmail({ type: "EmailVerification", email: user.email, userId: data.key });
                        }
                        return false;
                      });
                    } else {
                      this.error = { type: "expireButUserNotFound", message: "Lütfen e-posta kutunuza gelen en son doğrulama mailine bakın." }
                    }
                    this.cd.markForCheck();
                  })
                  break;
                default:
                  break;
              }
            });
        } catch (e) {
        }
      }
    }))
  }

  updatePassword() {
    if (this.updatePasswordModel.password == this.updatePasswordModel.confirmPassword) {
      firebase.auth().confirmPasswordReset(this.oobCode, this.updatePasswordModel.password).then(() => {
        this.router.navigate(['/auth']);
      });
      this.alertService.success('Şifreniz Değiştirildi!');
    } else {
      this.alertService.success('Şifreleriniz uyuşmuyor!');
    }
  }
  // sendEmail() {
  //   firebase.database().ref("users").orderByChild("email").equalTo(this.model.email).once("value", snap => {
  //     if (snap.exists()) {
  //       snap.forEach(data => {
  //         let user = data.val();
  //         this.userService.sendEmail({ type: "EmailVerification", email: user.email, userId: data.key }).then(() => this.error = { type: "expireButUserNotFound", message: "Kayıt e-postası tekrardan gönderildi. Eposta kutunu kontrol et." });
  //         return false;
  //       });
  //     } else {
  //       this.error = { type: "expireButUserNotFound", message: "Sistemimizde böyle bir eposta ile kayıtlı kullanıcı bulunmamaktadır. Lütfen tekrardan kayıt olmayı deneyin." }
  //     }
  //   })
  // }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/auth-actions/auth-actions.component.ts